

































































import { Component, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { showHttpErrorAlert } from '@/plugins/helper'
import AppNavDrawer from '@/components/AppNavDrawer.vue'

@Component({
  components: {
    AppNavDrawer
  }
})
export default class PageViewVehicleProfiles extends Vue {
  headers = [
    { text: 'Profile ID', value: 'profileId' },
    { text: 'Customer', value: 'customer' },
    { text: 'Brand & Model', value: 'brandModel' },
    { text: 'VIN Number', value: 'vinNumber' },
    { text: 'License Plate', value: 'licensePlate' },
    { text: 'License Photo', value: 'licensePhotos' },
    { text: 'Type & Engine', value: 'typeEngine' },
    { text: 'Created At', value: 'createdAt' },
    { text: 'Active at', value: 'activeAt' }
  ]

  items = []
  isLoadingItems = false

  created () {
    this.fetchVehicleProfiles()
  }

  async fetchVehicleProfiles () {
    try {
      this.isLoadingItems = true
      const { data } = await axiosInstance.get('/portal/insurance/vehicle-profiles')
      this.items = data.data.map((item: any) => {
        return {
          profileId: item.profile_id,
          customerUuid: item.customer_uuid,
          customerName: item.customer_name,
          customerTel: item.customer_tel,
          brand: item.brand,
          model: item.model,
          vinNumber: item.vin_number,
          licensePlate: item.license_plate,
          licensePhotos: item.license_photos,
          vehicleTypeId: item.vehicle_type_id,
          vehicleTypeNameEn: item.vehicle_type_name_en,
          vehicleEngineId: item.vehicle_engine_id,
          vehicleEngineNameEn: item.vehicle_engine_name_en,
          createdAt: item.created_at,
          activeAt: item.active_at
        }
      })
      this.isLoadingItems = false
    } catch (error) {
      this.isLoadingItems = false
      showHttpErrorAlert(error)
    }
  }
}
